import { InputFeedback } from "@songtradr-one/components-frontend";
import { Container, Label, Props } from "./FormFieldWrapper.Parts";

export const FormFieldWrapper = ({
  children,
  error,
  label,
  name,
  className,
  $single,
}: Props) => {
  return (
    <Container className={className} $single={$single}>
      {label && (
        <Label htmlFor={name} id={name ? `${name}-label` : undefined}>
          {label}
        </Label>
      )}
      {children}
      {error && <InputFeedback message={String(error.message)} />}
    </Container>
  );
};
